import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@htx/environment';
import { Config } from './config.model';

/**
 * This service loads the configuration in production from the assets/config.json file
 * applied during deployment. This allows changing the configuration for different
 * environments without rebuilding the application. (rancher / stackit)
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Config | null = null;
  readonly http = inject(HttpClient);

  private applyToEnvironment(config: Config): void {
    environment.apiUrl = config.apiUrl;
    environment.managementUrl = config.managementUrl;
    (environment as Record<string, unknown>)['oauth'] = config.oauth ?? null;
    if (config.apiKey) {
      (environment as Record<string, unknown>)['apiKey'] = config.apiKey;
    }
  }

  async loadConfig(): Promise<void> {
    if (environment.production) {
      this.config = await firstValueFrom(this.http.get<Config>('/assets/config.json'));
      this.applyToEnvironment(this.config);
    }
  }

  getConfig(): Config | null {
    return this.config;
  }
}
